import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.reduce.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { defaultIMoqsDiscountData, getMoqsDiscountById, manageMoqsDiscount, getMoqsDiscounts, createMoqsDiscount } from '@/api/moqs-discounts';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
import { Action } from 'vuex-module-decorators';
import { getProductById, getVariations, searchProducts } from '@/api/products';
import { getQuery } from '@/utils';
import { getDealersRoles } from '@/api/dealers-roles';
import { getBranches } from '@/api/locations/branches';
import { getRanges } from '@/api/ranges';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.formData = Object.assign({}, defaultIMoqsDiscountData);
    this.loading = false;
    this.productList = [];
    this.roleList = [];
    this.moqsDiscountList = [];
    this.moqId = 0;
    this.selectedProduct = null;
    this.branchList = [];
    this.rangeList = [];
    this.rules = {
      productId: {
        required: !this.formData.isNewScheme,
        message: 'This field is required',
        trigger: 'blur'
      },
      dealersRoleId: {
        required: !this.formData.isNewScheme,
        message: 'This field is required',
        trigger: 'blur'
      },
      branchId: {
        required: !!this.formData.isNewScheme,
        message: 'This field is required',
        trigger: 'blur'
      },
      rangeId: {
        required: !!this.formData.isNewScheme,
        message: 'This field is required',
        trigger: 'blur'
      }
    };
  }
  get lang() {
    return AppModule.language;
  }
  activated() {
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id;
      this.fetchData(parseInt(id));
    } else {
      this.formData = Object.assign({}, defaultIMoqsDiscountData);
      // assign moq ID
      this.moqId = parseInt(this.$route.params && this.$route.params.moqId);
      this.formData.moqId = this.moqId;
    }
    // get dealers roles
    this.fetchDealersRoles();
    this.fetchBranches();
    this.fetchRanges();
    this.tempTagView = Object.assign({}, this.$route);
  }
  async fetchRanges() {
    this.rangeList = await getRanges(getQuery({
      enabled: true,
      sort: 'name,ASC',
      filter: {
        enabled: '$eq'
      }
    }));
  }
  async fetchData(id) {
    try {
      const data = await getMoqsDiscountById(id);
      this.formData = data;
      this.moqId = data.moqId;
      // get selected product
      if (this.formData.productId) {
        const selectedProduct = await getProductById(this.formData.productId);
        this.productList = [selectedProduct];
        // fetch variations
        this.fetchVariantions();
      }
      // Just for test
      const title = '#' + this.formData.id;
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async fetchProducts(query) {
    try {
      if (query.length > 2) {
        this.productList = await searchProducts(getQuery({
          keyword: query
        }));
      }
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async fetchVariantions() {
    this.moqsDiscountList = [];
    if (this.formData.productId && this.formData.dealersRoleId || this.formData.productId && this.formData.isNewScheme) {
      const productId = this.formData.productId;
      const dealersRoleId = this.formData.dealersRoleId;
      // get selected product
      this.selectedProduct = await getProductById(productId);
      // get variations for selected product
      const variations = await getVariations(getQuery({
        productId,
        sort: 'name,ASC',
        filter: {
          productId: '$eq'
        }
      }));
      // map data
      if (variations.length) {
        // check if variation already saved to moq discounts
        const savedVariations = await getMoqsDiscounts(getQuery({
          moqId: this.moqId,
          dealersRoleId,
          productId,
          filter: {
            moqId: '$eq',
            productId: '$eq',
            dealersRoleId: '$eq'
          }
        }));
        // map variation ID to each object
        const moqObj = savedVariations.reduce((acc, obj) => {
          acc[obj.productsVariationId] = obj;
          return acc;
        }, {});
        for (const variant of variations) {
          const objToSave = {
            enabled: true,
            moqId: this.moqId,
            dealersRoleId: this.formData.dealersRoleId,
            productId,
            productsVariation: {
              id: variant.id,
              name: variant.name
            },
            looseQuantity: 0,
            cartonQuantity: 0,
            minimumQuantity: 0,
            discount: 0
          };
          if (moqObj.hasOwnProperty(variant.id)) {
            objToSave.id = moqObj[variant.id].id;
            objToSave.looseQuantity = moqObj[variant.id].minimumQuantity;
            objToSave.minimumQuantity = moqObj[variant.id].minimumQuantity;
            objToSave.discount = moqObj[variant.id].discount;
          }
          this.moqsDiscountList.push(objToSave);
        }
      }
    }
  }
  async fetchDealersRoles() {
    this.roleList = await getDealersRoles(getQuery({
      enabled: true,
      sort: 'name,ASC',
      filter: {
        enabled: 'eq'
      }
    }));
  }
  async fetchBranches() {
    this.branchList = await getBranches(getQuery({
      enabled: true,
      sort: 'name,ASC',
      filter: {
        enabled: 'eq'
      }
    }));
  }
  quantityChange(index, qtyType = 'carton') {
    switch (qtyType) {
      case 'pieces':
        this.moqsDiscountList[index].cartonQuantity = 0;
        this.moqsDiscountList[index].minimumQuantity = this.moqsDiscountList[index].looseQuantity;
        break;
      case 'carton':
        this.moqsDiscountList[index].looseQuantity = 0;
        this.moqsDiscountList[index].minimumQuantity = this.moqsDiscountList[index].cartonQuantity * this.selectedProduct.masterCarton;
        if (this.formData.isNewScheme) {
          this.moqsDiscountList[index].minimumCartonQuantity = this.moqsDiscountList[index].cartonQuantity;
          this.moqsDiscountList[index].isNewScheme = this.formData.isNewScheme;
          this.moqsDiscountList[index].branchId = this.formData.branchId;
          this.moqsDiscountList[index].rangeIdId = this.formData.rangeId;
        }
        break;
      default:
        break;
    }
    // validate percent
    this.validatePercent(index);
  }
  validatePercent(index) {
    if (this.moqsDiscountList[index].minimumQuantity) {
      if (!this.moqsDiscountList[index].discount) {
        this.moqsDiscountList[index].discount = '1';
      }
    } else {
      this.moqsDiscountList[index].discount = 0;
    }
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  async saveForm() {
    try {
      this.loading = true;
      for (const key in this.moqsDiscountList) {
        // remove rows with quantity: 0
        if (this.moqsDiscountList[key].minimumQuantity === 0) {
          if (this.moqsDiscountList[key].id) {
            this.moqsDiscountList[key].enabled = false;
          } else {
            this.moqsDiscountList.splice(+key, 1);
          }
        }
      }
      if (this.moqsDiscountList.length) {
        await manageMoqsDiscount(this.moqsDiscountList);
      } else if (this.moqsDiscountList.length === 0 && this.formData.isNewScheme) {
        await createMoqsDiscount(this.formData);
      }
      this.loading = false;
      this.$notify({
        title: 'Success',
        message: 'Moq discount saved',
        type: 'success',
        duration: 2000
      });
      // router.push("/moqs-discounts/list/" + this.formData.moqId);
    } catch (err) {
      this.loading = false;
    }
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'MoqsDiscountDetail',
  components: {}
})], default_1);
export default default_1;